import { Construction } from "lucide-react";

import { useTranslation } from "~/i18n";
import { cn } from "~/utils";

interface WorkInProgressProps {
  className?: string;
  headingLevel?: 1 | 2;
}

export function WorkInProgress({
  className,
  headingLevel = 2,
}: WorkInProgressProps) {
  const { t } = useTranslation();
  const Heading = headingLevel === 1 ? "h1" : "h2";

  return (
    <section
      className={cn(
        "w-full max-w-2xl rounded-panel border border-border bg-surface px-6 py-7 shadow-raised sm:px-8 sm:py-9",
        className,
      )}
    >
      <div className="flex items-start gap-4">
        <div
          aria-hidden="true"
          className="grid size-11 shrink-0 place-items-center rounded-xl bg-canvas text-brand"
        >
          <Construction className="size-5 stroke-[2.25]" />
        </div>
        <div className="min-w-0 pt-0.5">
          <Heading className="text-lg font-extrabold leading-7 text-foreground">
            {t("common.workInProgress.title")}
          </Heading>
          <p className="mt-1 text-sm font-medium leading-6 text-muted">
            {t("common.workInProgress.description")}
          </p>
        </div>
      </div>
    </section>
  );
}
